import { render, staticRenderFns } from "./PremiumSelect.vue?vue&type=template&id=63ed66ae&scoped=true"
import script from "./PremiumSelect.vue?vue&type=script&lang=js"
export * from "./PremiumSelect.vue?vue&type=script&lang=js"
import style0 from "./PremiumSelect.vue?vue&type=style&index=0&id=63ed66ae&prod&scoped=true&lang=css"
import style1 from "./PremiumSelect.vue?vue&type=style&index=1&id=63ed66ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed66ae",
  null
  
)

export default component.exports